module.exports = __webpack_public_path__ + "Flag-356.7ba534772978c0afc72b403ad48fd92d.svg";